import useSWR from 'swr';
import { getStoreOpenInteriorDetailUrl } from '@/constant/approval';
import { getNestedDataFetcher } from '@/utils/apis';
import type { StoreOpenInteriorDetail } from '@/utils/approval/storeOpen';

type Response = {
  interiorDetail: StoreOpenInteriorDetail | null;
  /** source=legacy 일 때 레거시가 매장 선택 시 저장한 상세 팝업 HTML */
  legacyContent?: string | null;
};

/** (구)매장 OPEN 품의(8) 저장 문서의 인테리어 비용 상세 — 「상세보기」를 열 때만 조회 */
const useStoreOpenInteriorDetail = (
  documentId: string | null | undefined,
  enabled: boolean,
) => {
  const { data, error, isLoading } = useSWR(
    enabled && documentId ? getStoreOpenInteriorDetailUrl(documentId) : null,
    (url: string) => getNestedDataFetcher<Response>(url),
    { revalidateOnFocus: false },
  );
  return {
    detail: data?.interiorDetail ?? null,
    legacyHtml: data?.legacyContent || null,
    isLoading,
    isError: !!error,
  };
};

export default useStoreOpenInteriorDetail;
